<template>
  <div>
    <div class="flex justify-between items-center my-8">
      <div>
        <h2 class="text-2xl font-semibold">Future Fit Corporate</h2>
      </div>
      <div class="flex">
        <base-button outline type="primary" class="flex px-3 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchSelected"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="GetAppUserData.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export Selected
          </download-excel>
        </base-button>
        <base-button outline type="primary" class="flex px-3 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="GetAppUserData.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export All
          </download-excel>
        </base-button>
      </div>
    </div>
    <div class="flex gap-4">
      <div class="w-full">
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            v-model="search"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
              @click=""
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <el-table
      border
      :data="ffc_form.result"
      style="width: 100%"
      class="mt-4 rounded"
      header-row-class-name="thead-light table-th-color "
      @selection-change="selectedRow"
    >
      <el-table-column type="selection" min-width="50px"> </el-table-column>

      <el-table-column
        prop="name"
        label="Name"
        v-slot="{ row }"
        min-width="150px"
      >
        {{ row.name }}
      </el-table-column>
      <el-table-column
        prop="email"
        label="Email"
        v-slot="{ row }"
        min-width="150px"
      >
        {{ row.email }}
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="Mobile"
        v-slot="{ row }"
        min-width="150px"
      >
        {{ row.mobile }}
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="Company Name"
        v-slot="{ row }"
        min-width="150px"
      >
        {{ row.companyName }}
      </el-table-column>
      <el-table-column
        prop="services"
        label="Services"
        v-slot="{ row }"
        min-width="150px"
      >
        {{ row.services }}
        <!-- <template v-for="(role, index) in row.role">
          <span>{{ index + 1 + ". " + role }}</span>
          <br />
        </template> -->
      </el-table-column>
      <el-table-column
        prop="description"
        label="Description"
        v-slot="{ row }"
        min-width="150px"
      >
        {{ row.description }}
      </el-table-column>
      <el-table-column
        label="Created On"
        prop="editedby"
        min-width="130px"
        v-slot="{ row }"
      >
        {{ new Date(row.createdAt).toDateString() }}
      </el-table-column>
      <el-table-column
        label="Actions"
        min-width="80px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <!-- <div class="flex">
              <feather-icon
                icon="Edit2Icon"
                svgClasses="w-4 text-blue-600 cursor-pointer"
                class="ml-2"
                v-b-modal.modal-1
              ></feather-icon>
            </div> -->

            <div class="flex" @click="handleDelete(scope.row._id)">
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 text-red-600 cursor-pointer"
                class="ml-2"
              ></feather-icon>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @change="handlePageChange"
      ></b-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import _ from "lodash";
import { mapState } from "vuex";
import FileUploader from "../../../../../components/FileUploader.vue";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    FileUploader,
  },
  data() {
    return {
      search: "",
      totalRows: 0,
      meditationId: "",
      perPage: 10,
      currentPage: 1,
      selectedData: [],
    };
  },
  methods: {
    async fetchData() {
      let payload = {};

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("services/getAppForm", payload);
        if (data.code == 200) {
          loader.close();
          this.$swal({
            // title: "No Selection!",
            html: `<p class="text-center">Data has been successfully exported!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
            // confirmButtonText: "Yes, delete it!",
          });
          return data.data.record;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async fetchSelected() {
      if (this.selectedData.length === 0) {
        return this.$swal({
          title: "No Selection!",
          html: `<p class="text-center">Please select rows to be exported!</p>`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
          // confirmButtonText: "Yes, delete it!",
        });
      }
      let loader = this.$loading();
      try {
        loader.close();
        this.$swal({
          // title: "No Selection!",
          html: `<p class="text-center">Data has been successfully exported!</p>`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
          // confirmButtonText: "Yes, delete it!",
        });
        return this.selectedData;
      } catch (error) {
        loader.close();
      }
    },
    handlePageChange(value) {
      try {
        this.currentPage = value;
        this.getFFCData();
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(id) {
      let loader;
      let payload = {
        _id: id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch("ffc/delete_form", payload);
        loader.close();
        if (data.code === 200) {
          this.getFFCData();
          await this.$swal({
            text: "Deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },

    async getFFCData() {
      let loader;
      let payload = {
        search: this.search,
        offset: (this.currentPage - 1) * 10,
        limit: 10,
      };
      try {
        loader = this.$loading();
        await this.$store.dispatch("ffc/get_form", payload);
        this.totalRows = this.ffc_form.totalCount;
        loader.close();
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    selectedRow(val) {
      this.selectedData = val;
    },
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getFFCData();
      }, 500),
    },
  },
  computed: {
    ...mapState("ffc", {
      ffc_form: "ffc_form",
    }),
    json_fields() {
      return {
        first_name: "name",
        email_id: "email",
        mobile_no: "mobile",
        role: "role",
        description: "description",
        Subscribed: "isSubscribed",
        created_at: {
          field: "createdAt",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
      };
    },
  },
  async mounted() {
    this.getFFCData();
    console.log(this.ffc_form);
  },
};
</script>

<style>
.width100 {
  width: 100px;
  height: 100px !important;
}
</style>
